'use client';

import type { FC, ReactNode } from 'react';
import { LazyMotion } from 'motion/react';

// Animation features load in a separate async chunk, off the critical path:
// initial bundles only carry the tiny `m` component shells, so hydration
// never blocks on the animation runtime (research R2). Mounted once at the
// root (see app/providers.tsx); `m.*` components anywhere in the tree pick
// the features up via context once they arrive.
const loadFeatures = () => import('./features').then(mod => mod.default);

export const LazyMotionProvider: FC<{ children: ReactNode }> = ({ children }) => (
  <LazyMotion features={loadFeatures}>{children}</LazyMotion>
);
